import axios from "axios";
import fileDownload from "js-file-download"
import {S3_BUCKETS} from "../backendServices/s3";

const getAuthHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('idToken')}` })

export const getProjectNoMask = async (projectId) => {
    const headers = getAuthHeader()
    const response = await axios.get(`/service/project/${projectId}`, { headers })
    return response.data;
}

export const getNowReadyConfiguration = async (projectId) => {
    const headers = getAuthHeader()
    const response = await axios.get(`/service/nowReadyConfiguration/${projectId}`, { headers })
    return response.data;
}

export const setNowReadyConfiguration = async (brandConfiguration) => {
    const headers = getAuthHeader()
    await axios.post(`/service/nowReadyConfiguration/${brandConfiguration.projectId}`, brandConfiguration, { headers })
}

export const getNowReadyConfigurationsForAccount = async (accountId) => {
    const headers = getAuthHeader()
    const response = await axios.get(`/service/nowReadyConfiguration/account/${accountId}`, { headers })
    return response.data;
}

export const updateRegistrationTtl = async (projectId, registrationTtl) => {
    const headers = getAuthHeader()
    const data = {
        projectId,
        registrationTtl
    }
    await axios.post(`/service/updateHelloRegistrationTtl`, data, { headers })
}

export const getAccount = async (accountId) => {
    const headers = getAuthHeader()
    const response = await axios.get(`/service/account?id=${accountId}`, { headers })
    return response.data;
}

export const transformLogo = async (logoFile, accountId) => {
    const headers = getAuthHeader()
    const formData = new FormData();
    formData.append("logo", logoFile)
    formData.append("accountId", accountId)
    const transformLogoResponse = await axios.post('/service/transformNowReadyLogo', formData, { headers })
    return transformLogoResponse.data
}

export const uploadToS3 = async (file, accountId, bucketKey) => {
    const headers = getAuthHeader()
    const formData = new FormData();
    if(!Object.values(S3_BUCKETS).includes(bucketKey)){
        throw new Error("Invalid bucket key")
    }
    formData.append("file", file)
    formData.append("accountId", accountId)
    formData.append("s3BucketKey", bucketKey)
    const response = await axios.post('/service/uploadToS3', formData, { headers, responseType: "blob" })
    return response.data
}

export const setSecureHelloOrdersFlag = async (accountId, isSecureHelloOrders) => {
    const headers = getAuthHeader()
    const data = {
        accountId,
        isSecureHelloOrders
    }
    await axios.post(`/service/setSecureHelloOrdersFlag`, data, { headers })
}

export const getSecureHelloOrdersFlag = async (accountId) => {
    const headers = getAuthHeader()
    const response = await axios.get(`/service/getSecureHelloOrdersFlag/account/${accountId}`, { headers })
    return response.data;
}

export const getCartoRecordsForAccount = async (accountId) => {
    const headers = getAuthHeader()
    const response = await axios.get(`/service/getCartoMapsByAccount/account/${accountId}`, { headers })
    return response.data;
}

export const getImportCsvRecordsForAccount = async (accountId) => {
    const headers = getAuthHeader()
    const response = await axios.get(`/service/getImportCsvRecordsByAccount/account/${accountId}`, { headers })
    return response.data;
}

export const createCartoMapRecord = async (accountId, visualisationName , zoneIds, startTime, endTime) => {
    const headers = getAuthHeader()
    const data = {
        accountId,
        visualisationName,
        zoneIds,
        startTime,
        endTime
    }
    const result = await axios.post(`/service/createCartoMap`, data, { headers })
    return result.data;
}

export const updateImportCsvRecord = async (recordId, accountId, status) => {
    const headers = getAuthHeader()
    const data = {
        accountId,
        recordId,
        status
    }
    const result = await axios.post(`/service/updateImportCsvRecord`, data, { headers })
    return result.data
}

export const getFromS3 = async (bucketKey, fileName) => {
    const headers = getAuthHeader()
    headers['responseType'] = 'blob'
    const result = await axios.get(`/service/getFromS3?s3BucketKey=${bucketKey}&fileName=${fileName}`, { headers })
    fileDownload(result.data, fileName)
}

export const getSuperUserInfo = async () => {
    const headers = getAuthHeader()
    const result = await axios.get(`/service/getSuperUsers`, { headers })
    return result.data
}

export const getAccountInfo = async () => {
    const headers = getAuthHeader()
    const result = await axios.get(`/service/accountList?showDeleted=true`, { headers })
    return result.data
}
